<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <span>进货商品</span>
            <div>
              <el-button type="primary" size="small" @click="_openAddShopHouseModal()">
                <i class="el-icon-plus"></i>选择商品
              </el-button>
            </div>
          </div>
          <div class="ibox-content">
            <el-table
              :data="upShopHouseInManageInfo.inoutOrderProducts"
              style="width: 100%"
              border
              stripe>
              <el-table-column prop="coverPhoto" label="商品图片" align="center" width="120">
                <template slot-scope="scope">
                  <img :src="scope.row.coverPhoto" style="width: 60px; height: 60px; border-radius: 5px;">
                </template>
              </el-table-column>
              <el-table-column prop="productId" label="编号" align="center"></el-table-column>
              <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
              <el-table-column prop="defaultSpecValue.specName" label="规格" align="center"></el-table-column>
              <el-table-column prop="defaultSpecValue.stock" label="库存" align="center"></el-table-column>
              <el-table-column label="数量" align="center">
                <template slot-scope="scope">
                  <el-input 
                    v-model.number="scope.row.count" 
                    type="number" 
                    @input="_caculTotalMount()"
                    @change="_caculTotalMount()"
                    @keyup.native="_caculTotalMount()"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="单价" align="center">
                <template slot-scope="scope">
                  <el-input 
                    v-model.number="scope.row.price" 
                    type="number" 
                    @input="_caculTotalMount()"
                    @change="_caculTotalMount()"
                    @keyup.native="_caculTotalMount()"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                  <el-button 
                    type="text" 
                    size="small" 
                    @click="_deleteProduct(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              layout="prev, pager, next"
              :total="total"
              :page-size="pageSize"
              @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <span>说明</span>
          </div>
          <div class="ibox-content">
            <el-form label-width="100px">
              <el-form-item label="总金额">
                <span style="font-size: 14px;color: red;">{{upShopHouseInManageInfo.totalMount}}</span>
              </el-form-item>
              <el-form-item label="选择供应商">
                <el-select 
                  v-model="upShopHouseInManageInfo.rsId" 
                  placeholder="请选择供应商"
                  style="width:100%"
                  @change="_changeResourceSupp">
                  <el-option 
                    v-for="item in upShopHouseInManageInfo.resourceSuppliers"
                    :key="item.rsId"
                    :label="item.supplierName"
                    :value="item.rsId">
                  </el-option>
                </el-select>
                <el-link type="primary" @click="_addSupplier()" style="margin-left: 20px;">新增供应商</el-link>
              </el-form-item>
              <el-form-item label="进货说明">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="必填，请填写进货说明"
                  v-model="upShopHouseInManageInfo.remark"
                  maxlength="250">
                </el-input>
              </el-form-item>
              <el-form-item label="进货流程">
                <img src="/img/inOrder.png">
              </el-form-item>
            </el-form>
            <div style="text-align: right; margin-top: 20px;">
              <el-button type="warning" @click="_goBack()" style="margin-right: 20px;">
                <i class="el-icon-close"></i>取消
              </el-button>
              <el-button type="primary" @click="_doInoutOrder()">
                <i class="el-icon-check"></i>提交
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <choose-product-and-spec ref="chooseProductAndSpec" @chooseProductAndSpec="_handleChooseProducts"></choose-product-and-spec>
  </div>
</template>

<script>
import { saveInoutOrder } from '@/api/goods/upShopHouseInManageApi'
import { listResourceSuppliers } from '@/api/goods/resourceSupplierApi'
import { getShopId } from '@/api/shop/shopApi'
import ChooseProductAndSpec from '@/components/goods/chooseProductAndSpec'

export default {
  components: {
    ChooseProductAndSpec
  },
  data() {
    return {
      upShopHouseInManageInfo: {
        rsId: '',
        shId: '',
        supplierName: '',
        resourceSuppliers: [],
        inoutOrderProducts: [],
        remark: '',
        totalMount: 0.00,
        orderType: '10000',
        shopId: ''
      },
      total: 0,
      pageSize: 10
    }
  },
  created() {
    this.upShopHouseInManageInfo.shopId = getShopId()
    this._listResourceSuppliers()
  },
  mounted() {
    console.log(this.total)
  },
  methods: {
    _openAddShopHouseModal() {
      this.$refs.chooseProductAndSpec.open()
    },
    _handleChooseProducts(products) {
      // products 是一个数组，将选中的商品添加到列表中
      if (products && products.length > 0) {
        products.forEach(product => {
          // 检查商品是否已存在（避免重复添加）
          const exists = this.upShopHouseInManageInfo.inoutOrderProducts.some(
            item => item.productId === product.productId && 
                    item.defaultSpecValue && 
                    product.defaultSpecValue &&
                    item.defaultSpecValue.valueId === product.defaultSpecValue.valueId
          )
          if (!exists) {
            // 为每个商品添加 count 和 price 字段
            const newProduct = {
              ...product,
              count: 1,
              price: product.defaultSpecValue ? product.defaultSpecValue.price : 0
            }
            this.upShopHouseInManageInfo.inoutOrderProducts.push(newProduct)
          }
        })
        // 重新计算总金额
        this._caculTotalMount()
      }
    },
    _doInoutOrder() {
      let _inoutOrderProducts = this.upShopHouseInManageInfo.inoutOrderProducts
      if (_inoutOrderProducts.length < 1) {
        this.$message.warning('请选择商品')
        return
      }
      
      _inoutOrderProducts.forEach(item => {
        item.valueId = item.defaultSpecValue.valueId
        item.specName = item.defaultSpecValue.specName
      })

      saveInoutOrder(this.upShopHouseInManageInfo)
        .then(response => {
          this.$message.success(response.msg)
          this._goBack()
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    _goBack() {
      this.$router.go(-1)
    },
    _deleteProduct(product) {
      let index = this.upShopHouseInManageInfo.inoutOrderProducts.indexOf(product)
      if (index > -1) {
        this.upShopHouseInManageInfo.inoutOrderProducts.splice(index, 1)
      }
    },
    _listResourceSuppliers() {
      listResourceSuppliers({
        page: 1,
        row: 100,
        shopId: this.upShopHouseInManageInfo.shopId
      }).then(response => {
        this.upShopHouseInManageInfo.resourceSuppliers = response.data || []
      }).catch(error => {
        console.error('获取供应商列表失败:', error)
        this.$message.error('获取供应商列表失败')
      })
    },
    _changeResourceSupp(rsId) {
      this.upShopHouseInManageInfo.rsId = rsId
      const supplier = this.upShopHouseInManageInfo.resourceSuppliers.find(item => item.rsId == rsId)
      if (supplier) {
        this.upShopHouseInManageInfo.supplierName = supplier.supplierName
      }
    },
    _addSupplier() {
      this.$router.push('/pages/goods/resourceSupplierManage?returnFlag=1')
    },
    _caculTotalMount() {
      let j = 0
      try {
        this.upShopHouseInManageInfo.inoutOrderProducts.forEach(item => {
          if (!isNaN(item.count) && !isNaN(item.price) && item.count > 0 && item.price >= 0) {
            j += parseFloat(item.count) * parseFloat(item.price)
          }
        })
        this.upShopHouseInManageInfo.totalMount = j.toFixed(2)
      } catch (error) {
        this.upShopHouseInManageInfo.totalMount = "请输入正确的数字"
      }
    },
    handleCurrentChange(val) {
      console.log(val)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  border-color: #edf1f2;
  border-image: none;
  border-style: solid solid none;
  border-width: 4px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 15px 15px 7px;
  min-height: 48px;
}
.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>